<template>
  <div>
    <a-button @click="showModal" class="btn-outline-primary">
      قرارداد ها
    </a-button>

    <a-modal
      width="1000px"
      v-model="visible"
      title=" قرارداد های سمینار"
      on-ok="handleOk"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel"> بستن </a-button>
      </template>

      <div class="row justify-content-center" style="direction: rtl">
        <div class="col-md-12">
          <div>
            <section class="w-100 p-4 text-center">
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th scope="col">شناسه</th>
                      <th scope="col">شماره موبایل</th>
                      <th scope="col">نام و نام خانوادگی</th>
                      <th scope="col">شماره قرارداد</th>

                      <th scope="col">کارشناس فروش</th>
                      <th scope="col">کارشناس تماس گیرنده</th>
                      <th scope="col">مبلغ سرمایه گذاری</th>
                      <th scope="col">توضیحات</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in data">
                      <th scope="row">#{{ row.id }}</th>
                      <td>{{ row.phone }}</td>
                      <td>
                        <b-badge variant="light" class="text-dark"
                          >{{ row.name + " " + row.family }}
                        </b-badge>
                      </td>
                      <td>
                        <b-badge variant="light" class="text-dark"
                        >{{ row.unique_id }}
                        </b-badge>
                      </td>
                      <td>
                        <b-badge variant="light" class="text-dark">{{
                          row.seller
                            ? $root.full_name(
                                row.seller.firstname,
                                row.seller.lastname
                              )
                            : ""
                        }}</b-badge>
                      </td>
                      <td>
                        <b-badge variant="light" class="text-dark">{{
                            row.caller
                                ? $root.full_name(
                                    row.caller.firstname,
                                    row.caller.lastname
                                )
                                : ""
                          }}</b-badge>
                      </td>
                      <td>
                        {{ $root.number_format(row.amount) }}
                      </td>
                      <td>{{ row.description }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
            <a-row class="pagination">
              <a-pagination
                :total="total"
                :item-render="$root.itemRender"
                @change="getGuests(currentPage)"
                v-model="currentPage"
              />
            </a-row>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
export default {
  props: {
    seminar_id: {
      type: Number,
      default: "",
    },
    sans_id: {
      type: Number,
      default: "",
    },
    seller_id: {
      type: Number,
      default: "",
    },
    caller_id: {
      type: Number,
      default: "",
    },
  },
  data() {
    return {
      data: [],
      currentPage: 1,
      total: 0,
      loading: false,
      visible: false,
    };
  },
  methods: {
    async getGuests() {
      let _this = this;
      let url = `/seminars/contracts?page=${this.currentPage}&&seminar_id=${this.seminar_id}&&sans_id=${this.sans_id}&&seller_id=${this.seller_id}&&caller_id=${this.caller_id}`;
      await axios
        .get(url)
        .then(function (response) {
          _this.data = response.data.data.data;
          _this.total = response.data.data.total;
          _this.currentPage = response.data.data.current_page;
        })
        .catch(function (err) {
          _this.$root.handleAxiosError(err);
        });
    },
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      this.loading = true;
      setTimeout(() => {
        this.visible = false;
        this.loading = false;
      }, 3000);
    },
    handleCancel(e) {
      this.visible = false;
    },
  },
  mounted() {
    this.getGuests();
  },
};
</script>
